import React from 'react';
import { Button } from 'react-toolbox/lib/button';
import styles from 'components/AddButton.css';

const AddButton = props => <Button theme={styles} icon="add" {...props} />;

export default AddButton;
